<div class="modal-content templateUploader">
  <!--  TITLE HEADER-->
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="closeDialog()"
      aria-hidden="true"
    >
      ×
    </button>
    <h3 id="myModalLabel">Upload/Select Images</h3>
  </div>

  <!--  BODY -->
  <div class="modal-body row">
    <div class="col-lg-12">
      <span>Drop file on row to upload or edit URL to replace image. </span>
    </div>

    <div class="col-lg-12 flex-container__centered">
      <!-- CHECK BOX-->
      <div class="item-grow">
        <input
          [checked]="uploadInUserFolderDefault"
          (change)="checkboxUserFolderChanged($event.target.checked)"
          [disabled]="userFolder === null"
          type="checkbox"
          aria-label="..."
        />
        Upload in user's folder
      </div>

      <!-- ICON BUTTON | UPLOAD FROM LOCAL-->
      <div>
        <label class="btn btn-link">
          <input
            type="file"
            ngFileSelect
            [options]="options"
            (uploadOutput)="onUploadOutput($event)"
            [uploadInput]="uploadInput"
            multiple
            style="display: none"
            accept="image/*"
          />
          <span
            tooltip="Browse files on local drive"
            class="glyphicon glyphicon-folder-open"
            aria-hidden="true"
          ></span>
        </label>
      </div>

      <!-- ICON BUTTON | UPLOAD FROM SERVER -->
      <div>
        <label class="btn btn--orange" (click)="openBrowseUploadedImages()">
          <span
            tooltip="Browse files already uploaded on server"
            class="glyphicon glyphicon-folder-open"
            aria-hidden="true"
          ></span>
        </label>
      </div>
    </div>

    <div class="col-md-12">
      <!-- TABLE TO DISPLAY IMAGES UPLOADED -->
      <table
        class="table table-bordered table_vam table-search uploadImagesTable"
        style="table-layout: fixed"
      >
        <!-- HEADER TABLE -->
        <thead>
          <tr>
            <!-- COL#1 HEADER -->
            <th style="width: 15%" class="th-upper">Variable</th>

            <!-- COL#2 HEADER -->
            <th
              class="th-upper"
              ngFileDrop
              [options]="options"
              (uploadOutput)="onUploadOutput($event)"
              [uploadInput]="uploadInput"
            >
              Path & Filename (<span style="color: #1c87b2"
                >drop files here</span
              >)
            </th>

            <!-- COL#3 HEADER -->
            <th style="" class="th-upper">URL</th>

            <!-- COL#4 HEADER -->
            <th style="" class="th-upper">Progress</th>
          </tr>
        </thead>
        <!-- BODY TABLE -->
        <tbody>
          <!-- 1th row to display current selection -->
          <tr
            class="imageVariablesList"
            *ngFor="let file of files; let i = index"
          >
            <!-- COL#1 BODY -->
            <td class="varName">template.{{ templateModelImageVariable }}</td>

            <!-- COL#2 BODY -->
            <td class="fileName">
              <span
                (click)="
                  setEditableFlg('fileName', i.toString(), true);
                  setFocusForInput('fileName', i.toString())
                "
                *ngIf="!(fieldsEditable[i] && fieldsEditable[i]['fileName'])"
              >
                {{ file.name }}
              </span>
              <input
                *ngIf="fieldsEditable[i] && fieldsEditable[i]['fileName']"
                [id]="i + 'fileName'"
                type="text"
                placeholder="enter display name"
                class="form-control input--editable"
                [value]="file.name"
                (input)="file.name = $event.target.value"
                (blur)="setEditableFlg('fileName', i.toString(), false)"
                (keypress)="checkFieldAfterTyping(file.id, file.name)"
              />
              <span *ngIf="file.isExisting" style="color: red"
                ><br />
                Saving will replace existing file with same name
              </span>
              <span *ngIf="file.imageNameIncorrect" style="color: red"
              ><br />
                Filename cannot include special character or spaces
              </span>
            </td>

            <!-- COL#3 BODY -->
            <td class="srcName">
              <span>
                {{ file.url }}
              </span>
            </td>

            <!-- COL#4 BODY -->
            <td class="progressField flex-container">
              <span class="text-right">
                {{ file.progress.data.percentage }}% Uploaded
              </span>
              <span *ngIf="!displayCopy" class="imageUploadControls text-right">
                <button class="btn btn-link" aria-hidden="true">
                  <span
                    class="glyphicon glyphicon-refresh refresh"
                    aria-hidden="true"
                  ></span>
                </button>
                <button
                  class="btn btn-link"
                  aria-hidden="true"
                  (click)="removeFile(file.id, file.name)"
                >
                  <span
                    class="glyphicon glyphicon-remove remove"
                    aria-hidden="true"
                  ></span>
                </button>
                <button
                  class="btn btn-link"
                  aria-hidden="true"
                  tooltip="Preview an image"
                  (click)="openPreview(file)"
                >
                  <span
                    class="glyphicon glyphicon-eye-open"
                    aria-hidden="true"
                  ></span>
                </button>
                <button
                  class="btn btn-link"
                  aria-hidden="true"
                  tooltip="Copy the link for this image to the clipboard"
                  (click)="copyTextToClipboard(file.url)"
                >
                  <span
                    class="glyphicon glyphicon-link"
                    aria-hidden="true"
                  ></span>
                </button>
              </span>
              <div
                *ngIf="displayCopy"
                style="
                  width: 100%;
                  margin-top: 1px;
                  margin-left: 8px;
                  margin-right: 8px;
                "
                class="imageUploadControls text-center copyBox"
              >
                Copied
              </div>
            </td>
          </tr>
          <!-- 2nd ROW to show current image selected -->
          <tr
            class="imageVariablesList"
            *ngIf="files.length === 0 && initialFile !== null"
          >
            <!-- COL#1 BODY -->
            <td class="varName">template.{{ templateModelImageVariable }}</td>
            <!-- COL#2 BODY -->
            <td class="fileName">
              <span>
                {{ initialFile.name }}
              </span>
            </td>
            <!-- COL#3 BODY -->
            <td class="srcName">
              <span>
                {{ initialFile.url }}
              </span>
            </td>
            <!-- COL#4 BODY -->
            <td class="progressField flex-container">
              <span class="text-right"> </span>
              <span *ngIf="!displayCopy" class="imageUploadControls text-right">
                <button
                  class="btn btn-link"
                  aria-hidden="true"
                  tooltip="Copy the link for this image to the clipboard"
                  (click)="copyTextToClipboard(initialFile.url)"
                >
                  <span
                    class="glyphicon glyphicon-link"
                    aria-hidden="true"
                  ></span>
                </button>
              </span>
              <div
                *ngIf="displayCopy"
                style="
                  width: 100%;
                  margin-top: 1px;
                  margin-left: 8px;
                  margin-right: 8px;
                "
                class="imageUploadControls text-center copyBox"
              >
                Copied
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- end IMAGES TABLE LIST -->
    </div>

    <!-- DROP FILE ZONE -->
    <div class="col-md-12 text-center">
      <div
        class="fileDropTag"
        ngFileDrop
        [options]="options"
        (uploadOutput)="onUploadOutput($event)"
        [uploadInput]="uploadInput"
        [ngClass]="{ 'drag-over': dragOver }"
      >
        <span>Drop files here</span>
      </div>
    </div>
  </div>

  <!--  FOOTER-->
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="useImages()" aria-hidden="true" [disabled]="disableUpload">
      <span>Use/Replace Images</span>
    </button>
    <button class="btn btn-default" aria-hidden="true" (click)="closeDialog()">
      Close
    </button>
  </div>
</div>
